// 当前用户的所有店铺数据
import { getShopList } from "@servers/base/shop/index.js";
import { PLATFORM_KEYS } from "@/dictionary/platforms.js";

const shops = {
  state: () => ({
    shops: [], // 全部店铺
    loadingPromises: {}, // 用于缓存正在进行的请求Promise，防止重复请求
    fxg_updateIndex: 0,
    kuaishou_updateIndex: 0,
    tb_updateIndex: 0, // 当前编辑的商品所在的店铺在平台店铺的索引
    pdd_updateIndex: 0,
    jd_updateIndex: 0,
    alibaba_updateIndex: 0,
    yz_updateIndex: 0,
    wxxd_updateIndex: 0,
    wxsph_updateIndex: 0,
    xhs_updateIndex: 0,
    xy_updateIndex: 0,
    pddtemu_updateIndex: 0,
    shein_updateIndex: 0,
  }),
  mutations: {
    setShops(state, shops) {
      state.shops = shops;
    },
    setLoadingPromises(state, promises) {
      state.loadingPromises = promises;
    },
    setLoadingPromise(state, { key, promise }) {
      state.loadingPromises[key] = promise;
    },
    setUpdateIndex(state, payload) {
      if(payload.platform != 'base' || payload.platform != 'tm') {
        state[`${payload.platform}_updateIndex`] = payload.index
      }
    }
  },
  actions: {
    async initShops({ commit, state }) {
      if (state.shops.length) return console.log("已加载过店铺");
      
      // 生成请求的唯一标识
      const requestKey = 'init-shops';
      
      // 如果已经有相同的请求在进行中，返回该Promise
      if (state.loadingPromises && state.loadingPromises[requestKey]) {
        return state.loadingPromises[requestKey];
      }
      
      // 创建新的请求Promise
      const requestPromise = (async () => {
        try {
          const res = await getShopList({
            pageNo: 1,
            pageSize: 9999,
          });
          commit("setShops", res.list);
          return res.list;
        } catch (error) {
          console.log("actions-initShops-error!###", error);
          throw error;
        } finally {
          // 请求完成后清除Promise缓存
          if (state.loadingPromises) {
            delete state.loadingPromises[requestKey];
          }
        }
      })();
      
      // 缓存Promise
      if (!state.loadingPromises) {
        commit('setLoadingPromises', {});
      }
      commit('setLoadingPromise', { key: requestKey, promise: requestPromise });
      
      return requestPromise;
    },
    async updateShops({ commit, state }, opts) {
      try {
        const res = await getShopList({
          pageNo: 1,
          pageSize: 9999,
        }, opts?.configs || {});
        commit("setShops", res.list);
        return res.list || [];
      } catch (error) {
        console.log("actions-initShops-error!###", error)
      }
    },
    clearShops({ commit }) {
      commit("setShops", []);
    },
    updateCatePropShopIndex({ commit, state, getters }, platformKey) {
      let shops = getters.shops_authorizedShops(platformKey);
      let currIndex = state[`${platformKey}_updateIndex`];
      
      currIndex = currIndex < (shops.length - 1) ? (currIndex + 1) : 0
      
      commit('setUpdateIndex', {
        platform: platformKey,
        index: currIndex
      })
    }
  },
  getters: {
    // 判断店铺是否已授权
    is_authorized_shop(state, getters) {
      return (platformKey, shopId) => {
        platformKey = platformKey === 'alibaba' ? '1688' : platformKey
        const shop = state.shops.find(item => item.id === shopId)
        // active === 0 || isDeadline === 1 为停用， state === 2 || 3 为已授权
        let commonCondition = [2, 3].includes(shop.state) && shop.isDeadline !== 1 && shop.active !== 0 && platformKey === (shop.subSource ? shop.subSource : shop.source);
        return commonCondition;
      };
    },
    // 获取平台已授权店铺
    shops_authorizedShops(state, getters) {
      return (platformKey) => {
        return state.shops.filter(item => getters.is_authorized_shop(platformKey, item.id));
      }
    },
    // 给平台接口作为默认店铺Id
    // 取已有店铺且已授权的第一个店铺
    shops_defaultShopId(state, getters) {
      return (platformKey) => {
        const shops = getters.shops_authorizedShops(platformKey);
        if (!shops.length) return null;
        return shops[0].id;
      };
    },

    // 给各平台调用类目属性相关接口的店铺id获取
    // 解决一些商户有多个店铺，但只有其中一个店铺类目属性全的情况
    // 获取方式：
    // 1. state中记录各个平台的当前店铺下标 比如fxg_updateIndex
    // 2. 从state.shops中过滤当前平台可用的店铺数据
    // 3. 取2中数据中的对应1中下标的数据进行返回
    shops_getCategoryPropShopId(state, getters) {
      return (platformKey) => {
        let updateIndex = state[`${platformKey}_updateIndex`] || 0;
        let shops = getters.shops_authorizedShops(platformKey);
        if (!shops.length) return null;
        if (shops.length <= updateIndex) {
          // 当前下标不在可用店铺数组内，则返回0下标的店铺
          updateIndex = 0
        }
        return shops[updateIndex]?.id
      }
    },
    shops_updateShopId(state, getters) {
      return (platformKey, updateIndex) => {
        let shops = getters.shops_authorizedShops(platformKey);
        if (!shops.length) return null;
        return shops[updateIndex].id;

      }; 
    },
    shops_updateIndex(state) {
      return (platform) => {
        return state[`${platform}_updateIndex`];
      }
    },
    shops_all(state) {
      return state.shops;
    },
    shops_all_ids(state) {
      return state.shops.map(shop => shop.id);
    },
    shops_all_userIds(state) {
      return state.shops.map(shop => shop.userId);
    },
    get_AllShops_BySource(state, getters) {
      return (platformKey) => {
        platformKey = platformKey === 'alibaba' ? '1688' : platformKey
        return state.shops.filter(shop => platformKey === (shop.subSource ? shop.subSource : shop.source));
      };
    },
    shops_getById(state) {
      return (id) => {
        return state.shops.find((shop) => shop.id === id);
      };
    },
    // 前端分页查询
    shops_queryList(state, getters) {
      return ({pageSize = 10, pageNo = 1} = {}) => {
        let allList = getters.shops_all.filter(item => [2, 3].includes(item.state))
        const startIndex = (pageNo - 1) * pageSize
        const endIndex = startIndex + pageSize
        return {
          list: allList.slice(startIndex, endIndex),
          total: allList.length
        } 
      }
    }
  },
};

export default shops;
